
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Auth , PubSub} from 'aws-amplify';

import {CognitoUserInterface, AuthState} from '@aws-amplify/ui-components';
import { GetusuariosService, Usuarios } from 'src/app/services/getusuarios.service';
import { GetenvironmentsService } from 'src/app/services/getenvironments.service';
import { GeteventsService } from 'src/app/services/getevents.service';
import { GetfridgeService } from 'src/app/services/getfridge.service';

@Component({
  selector: 'app-pagina-main-master',
  templateUrl: './pagina-main-master.component.html',
  styleUrls: ['./pagina-main-master.component.scss']
})
export class PaginaMainMasterComponent implements OnInit {

  DEBUG: boolean = false;
  
  valueProgress: number = 100; //Total de dispositivos a cargar
  bufferValue: number = 0;  // progreso 

  response: any;
  datomm: any = {};

  array_tab_usuarios: Usuarios[] = [];
  arry_usuarios: string [] = [];
  master:string;
  group:string;

  userid: string;
  timeini: number;
  timefin: number;
  time30min: number = 1800000; //30min en milisegundos
  arrayEnvironments: any;
  //arrayEvents: any;
  arrayFridge: any;

  user: CognitoUserInterface | undefined;
  authState: AuthState;

  flagUsuarios: boolean = false;

  // MQTT - AWS
  pubSubMQTT;
  temaMQTT: string;
  datosMQTT;
  dato: any;

  constructor(
    private getenvironmentsService: GetenvironmentsService,
    private getusuariosService: GetusuariosService, 
    private geteventsService: GeteventsService,
    private getfridgeService: GetfridgeService,
    private router: Router, 
    ) { 
      // OBTENEMOS el dato pasado por navigation Usuario del cuidador
      if(this.router.getCurrentNavigation().extras.state != undefined){
        this.master = this.router.getCurrentNavigation().extras.state.master; 
        this.group = this.router.getCurrentNavigation().extras.state.group; 
      }else{
        // console.log("MAIN MASTER volvemos")
        this.router.navigate(['/login-aws']);
      }

    }

  ngOnInit() {  

    //Obtenemos el cuidador pasado por route
    if(this.DEBUG){
      console.log("MASTER: " + this.master + " - " + this.group);

      // Cargamos los usuarios a cargo del cuidador
      console.log("API - asyncMethodUsuarios:");
    }

    // Escucha MQTT
    let topic: string = 'PharaOn/updateAWS/+';
    this.pubSubMQTT  = PubSub.subscribe(topic, { provider: 'AWSIoTProvider' }).subscribe({
      next: dataMQTT => {
        this.comprobarDispositivosMQTT(dataMQTT);
    },
      error: error => console.error(error)
    });
    
    //Envio de datos MQTT
    this.asyncEnvioDatosMQTT();

    this.funcionCarga();



    this.asyncMethodUsuarios();
    // console.log("flausuarios True 3");
  }

  funcionCarga(){

      setTimeout(() => {
        // console.log("flausuarios TrUE 1");
        this.bufferValue = 20;
        setTimeout(() => {
          // console.log("flausuarios TrUE 2");
          this.bufferValue = 40;
      
          setTimeout(() => {
            // console.log("flausuarios TrUE 3");
            this.bufferValue = 60;
            
            setTimeout(() => {
              // console.log("flausuarios TrUE 4");
              this.bufferValue = 80;
              
              setTimeout(() => {
                // console.log("flausuarios TrUE 5");
                this.bufferValue = 100;
                this.array_tab_usuarios.sort(function (a, b) {
                      // A va primero que B
                      if (a.useridCETEM < b.useridCETEM)
                      return -1;
                      // B va primero que A
                      else if (a.useridCETEM > b.useridCETEM)
                      return 1;
                      // A y B son iguales
                      else 
                      return 0;
                    });
                    // console.log (this.array_tab_usuarios);
                    this.flagUsuarios = true;
                
                }, 500);

              }, 500);

            }, 500);

          }, 500);
          
      }, 500);
   

  }
  

  async asyncMethodUsuarios() {
    if(this.DEBUG){
      console.log("SERVICE USUARIOS MASTER: " + this.master);
    }
    this.array_tab_usuarios = await this.getusuariosService.getUsuarios(this.master);
    if(this.DEBUG){
      console.log (this.array_tab_usuarios);
    }
    

    // this.asyncMethodComprobarDispositivos();
    this.asyncEnvioDatosMQTT();
  }

  async  asyncEnvioDatosMQTT() {
    // for (let i = 0; i < this.array_tab_usuarios.length; i++) {

      await PubSub.publish('PharaOn/esp32', { id: "X", action: "SENDATA" }, { provider: 'AWSIoTProvider' });
      await PubSub.publish('PharaOn/esp32', { id: "Y", action: "SENDATA" }, { provider: 'AWSIoTProvider' });
      await PubSub.publish('PharaOn/esp32', { id: "F", action: "SENDATA" }, { provider: 'AWSIoTProvider' });
    // }

  
  }


  async asyncMethodComprobarDispositivos() {
    if(this.DEBUG){
      console.log("SERVICE DISPOSITIVOS MASTER: " + this.master);
    }


    this.timeini = Date.now() - (this.time30min*2.1); // -1h;
    this.timefin = Date.now();

    if(this.DEBUG){
      console.log(this.timeini);
      console.log(this.timefin);
    }

    this.valueProgress = this.array_tab_usuarios.length; // Tamaño de la lista a comprobar

    for (let i = 0; i < this.array_tab_usuarios.length; i++) {

      this.bufferValue = i; // Progreso


      //Miramos dispositivo a dispositivo si hay datos y por la tanto conexión
      //DISPOSITIVO 1 
      // this.arrayEvents = [];
      // this.arrayEvents = await this.geteventsService.getEvents(this.array_tab_usuarios[i].disp1, this.timeini, this.timefin);
      this.arrayEnvironments = [];
      this.arrayEnvironments = await this.getenvironmentsService.getEnvironments(this.array_tab_usuarios[i].disp1, this.timeini, this.timefin);

      if(this.DEBUG){
        console.log("SERVICE ENVIRONMET: ");
        console.log (this.arrayEnvironments);
      }

      if(this.arrayEnvironments != undefined){
        if(this.arrayEnvironments.length == 0){
          this.array_tab_usuarios[i].estadoDisp1 = false;

        }else{
          this.array_tab_usuarios[i].estadoDisp1 = true;

        }
      }

      //DISPOSITIVO 2 
      // this.arrayEvents = [];
      // this.arrayEvents = await this.geteventsService.getEvents(this.array_tab_usuarios[i].disp2, this.timeini, this.timefin);
      this.arrayEnvironments = [];
      this.arrayEnvironments = await this.getenvironmentsService.getEnvironments(this.array_tab_usuarios[i].disp2, this.timeini, this.timefin);
      if(this.DEBUG){
        console.log("SERVICE ENVIRONMET: ");
        console.log (this.arrayEnvironments);
      }

      if(this.arrayEnvironments != undefined){
        if(this.arrayEnvironments.length == 0){
          this.array_tab_usuarios[i].estadoDisp2 = false;

        }else{
          this.array_tab_usuarios[i].estadoDisp2 = true;

        }
      }
      
      //DISPOSITIVO 3 
      this.arrayFridge = [];
      this.arrayFridge = await this.getfridgeService.getFridge(this.array_tab_usuarios[i].disp3, this.timeini, this.timefin);
      if(this.DEBUG){
        console.log("SERVICE FRIDGE: ");
        console.log (this.arrayFridge);
      }

      if(this.arrayFridge != undefined){
        if(this.arrayFridge.length == 0){
          this.array_tab_usuarios[i].estadoDisp3 = false;

        }else{
          this.array_tab_usuarios[i].estadoDisp3 = true;

        }
      }
    }

    if(this.DEBUG){
      console.log (this.array_tab_usuarios);
    }
    this.flagUsuarios = true;
  }


  comprobarDispositivosMQTT(dataMQTT: any){ 
    let id = dataMQTT.value.id;
    
    for (let i = 0; i < this.array_tab_usuarios.length; i++) {
      if(id == this.array_tab_usuarios[i].disp1){
        this.array_tab_usuarios[i].estadoDisp1 = true;
      }else if (id == this.array_tab_usuarios[i].disp2){
        this.array_tab_usuarios[i].estadoDisp2 = true;
      }else if (id == this.array_tab_usuarios[i].disp3){
        this.array_tab_usuarios[i].estadoDisp3 = true;
      }

    }
   }

   // BOTON ACTUALIZAR
   actualizar(){
    this.flagUsuarios = false;
    // this.asyncMethodComprobarDispositivos();
    this.asyncEnvioDatosMQTT();
    this.funcionCarga();
  }

// CARGAR USUARIO
  loadMainUser(arrayUser){
    if(this.DEBUG){
      console.log("LoadMainUser " + arrayUser.userid);
    }
    
    this.router.navigate(['/main-user', arrayUser.nombre], {state: {arrayUser: arrayUser, group: this.group}});  
  }

  // SALIR
   async signOut(){
    try {
      await Auth.signOut();
      // Hub.dispatch('UI Auth', {   // channel must be 'UI Auth'
      //       event: 'AuthStateChange',    // event must be 'AuthStateChange'
      //       message: 'signedout'    // message must be 'signedout'
      //   });
      if(this.DEBUG){
        console.log('signOut');
      }
      this.router.navigate(['/login-aws']);
    } catch (error) {
      if(this.DEBUG){
        console.log('error signing out: ', error);
      }
    }
  }

}